import { render, staticRenderFns } from "./LpCheck.vue?vue&type=template&id=4b0a4abd&scoped=true"
import script from "./LpCheck.vue?vue&type=script&lang=js"
export * from "./LpCheck.vue?vue&type=script&lang=js"
import style0 from "./LpCheck.vue?vue&type=style&index=0&id=4b0a4abd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a4abd",
  null
  
)

export default component.exports